import api from '../../config/AxiosService';
import { Inbox, InboxFile, Pagination } from '../../types';

export const getClientInboxes = async (clientName: string): Promise<Inbox[]> => {
  const response = await api.get(`/inbox/${clientName}/summary`);
  return response.data;
};

export const getClientInboxFileList = async (
  clientName: string,
  params: Pagination,
  doctype: string,
  queryString: string
): Promise<any> => {
  const response = await api.get(
    `/inbox/${clientName}/${doctype}/list?page=${params.page}&size=${params.pageSize}${queryString}`
  );
  return response.data;
};

export const getClientInboxFilePage = async (
  clientName: string,
  doctype: string,
  id: string,
  queryString: string
): Promise<any> => {
  const response = await api.get(`/inbox/${clientName}/${doctype}/${id}/get-page?${queryString}`);
  return response.data;
};

export const getClientInboxFile = async (file_id: string): Promise<InboxFile> => {
  const response = await api.get(`/inbox/${file_id}/one-inbox-file`);
  return response.data;
};

export const updateInboxFileStatus = async (file_id: string, status: string) => {
  return await api.put(
    `/inbox/${file_id}`,
    { status: status },
    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

export const updateClientInboxFilesStatus = async (
  clientName: string,
  doctype: string,
  queryString: string,
  status: string
): Promise<any> => {
  const response = await api.put(`/inbox/${clientName}/${doctype}/list?${queryString}`, { status: status });
  return response.data;
};

export const updateInboxFileTag = async (file_id: string, tag: string) => {
  return await api.put(
    `/inbox/${file_id}`,
    { tag: tag },
    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

export const getInboxFlowOptions = async (clientName: string): Promise<any> => {
  const response = await api.get(`/inbox/flows-for/${clientName}`);
  return response.data;
};

export const exportStagedInboxToDataset = async (
  datasetId: number,
  clientName: string,
  doctype: string
): Promise<any> => {
  const response = await api.post(`/inbox/add-to-dataset/${datasetId}/${clientName}/${doctype}`);
  return response;
};

export const deleteInboxFile = async (file_id: string) => {
  return await api.delete(`inbox/${file_id}`);
};
